import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { map, startWith, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-changing-carrier-dialog',
  templateUrl: './changing-carrier-dialog.component.html',
  styleUrls: ['./changing-carrier-dialog.component.scss']
})
export class ChangingCarrierDialogComponent implements OnInit {
  newCarrierInfoForm: FormGroup;
  filteredCarrierList: Observable<any[]> = of([]);

  constructor(
    public dialogRef: MatDialogRef<ChangingCarrierDialogComponent>,
    private fb: FormBuilder,
    private http: HttpClient
  ) {
    this.newCarrierInfoForm = this.fb.group({
      new_carrier_control: [''],
      carrier_contact_uuid: [''],
      carrier_name: [''],
      carrier_locality: ['']
    });
  }

  ngOnInit(): void {
    this.setupCarrierAutocomplete();
  }

  setupCarrierAutocomplete() {
    this.filteredCarrierList = this.newCarrierInfoForm.get('new_carrier_control')!.valueChanges.pipe(
      startWith(''),
      switchMap(value => {
        if (typeof value === 'string' && value.length >= 3) {
          return this.getCarrierList(value);
        } else {
          return of([]);
        }
      })
    );
  }

  getCarrierList(query: string): Observable<any[]> {
    const url = `/api/work_orders/contact_autofill.php?type=carrier_contact_list&search=${query}`;
    return this.http.get<any[]>(url).pipe(
      map(response => response || [])
    );
  }

  displayFn(carrier: any): string {
    return carrier && carrier.label ? carrier.label : '';
  }

  onCarrierSelected(selectedCarrier: any) {
    this.newCarrierInfoForm.get('carrier_contact_uuid')!.setValue(selectedCarrier.value);
    this.newCarrierInfoForm.get('carrier_name')!.setValue(selectedCarrier.label.split(' - ')[0]);

    // Fetch full carrier details to get locality from first address
    this.http.get(`/api/work_orders/contact_autofill.php?type=contact_data&uuid=${selectedCarrier.value}`).subscribe((details: any) => {
      const data = details[0];
      if (data && data.addresses && data.addresses.length > 0) {
        const firstAddr = data.addresses[0];
        this.newCarrierInfoForm.patchValue({
          carrier_locality: firstAddr.locality
        });
      } else {
        console.warn('No addresses found for selected carrier; locality not set.');
      }
    }, error => {
      console.error('Error fetching carrier details:', error);
    });
  }

  onSubmit(): void {
    if (this.newCarrierInfoForm.valid) {
      this.dialogRef.close(this.newCarrierInfoForm.value);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}